import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

export type userDataState = {
  user_name: string;
  name: string;
  access_token: string;
};

const initialState: userDataState = {
  user_name: "",
  name: "",
  access_token: "",
};

export const userDataSlice = createSlice({
  name: "userData",
  initialState,
  reducers: {
    setLogoutState: () => initialState,
    setUserData: (state, action: PayloadAction<userDataState>) => {
      state.user_name = action.payload.user_name;
      state.name = action.payload.name;
      state.access_token = action.payload.access_token;
    },
  },
});

export const { setUserData, setLogoutState } = userDataSlice.actions;

const persistConfig = {
  key: 'userData',
  storage,
};

const persistedUserDataReducer = persistReducer(persistConfig, userDataSlice.reducer);

export default persistedUserDataReducer;
